export default "__VITE_ASSET__Nn0wGogX__"